import { Component, OnInit } from '@angular/core';
import { GroupService } from '../../../shared/services/group.service';
import { ProductService } from '../../../shared/services/product.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.sass']
})
export class CategoriesComponent implements OnInit {
  constructor(private groupService: GroupService, private productService: ProductService) { }
  public categories: any[] = [];
  public filteredCategories: any[] = [];

  public getMethod() {
    forkJoin({
      categories: this.groupService.getGroups(),
      products: this.productService.getProducts()
    }).subscribe(({ categories, products }) => {
      if (Array.isArray(categories)) {
        this.filteredCategories = categories.filter(category => 
          products.some(product => product.category === category.nazivGrupe)
        );
      } else {
        console.error('Categories is not an array:', categories);
        this.filteredCategories = [];

      }
    });
  } 

  ngOnInit() {
    this.getMethod();
  }
}